import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {
  TranslationProvider,
  Link,
  containerQueryProps,
} from '@resy/ui-kitchen';

import CitiesList from '../CitiesList';
import './AllCities.scss';

const AllCities = (props) => {
  const {
    header,
    tagline,
    containerQuery: {
      xs, sm, md, lg, xl,
    },
    ...passThroughProps
  } = props;

  return (
    <div
      className={cx('AllCities', {
        'AllCities--xs': xs,
        'AllCities--sm': sm,
        'AllCities--md': md,
        'AllCities--lg': lg,
        'AllCities--xl': xl,
      })}
    >
      <div className="AllCities__headings">
        <h1 className="color--brand-primary">
          {header}
        </h1>
        <p className="color--text-secondary">
          {tagline}
        </p>
        <Link href="/about-and-help">
          <TranslationProvider translationKey="more_about_resy">
            <span>More about Resy&nbsp;&rsaquo;</span>
          </TranslationProvider>
        </Link>
      </div>
      {/* temporary until we build mobile version */}
      {md && (
        <div className="AllCities__cities">
          <CitiesList
            {...passThroughProps}
            allCities
          />
        </div>
      )}
    </div>
  );
};

AllCities.propTypes = {
  header: PropTypes.string.isRequired,
  tagline: PropTypes.string.isRequired,
  containerQuery: containerQueryProps,
};

AllCities.defaultProps = {
  containerQuery: {
    md: true,
  },
};

AllCities.displayName = 'AllCities';
export default AllCities;
